// Modules
import { useState } from "react";
import { HelmetProvider } from "react-helmet-async";

// Components
import Filters from "components/searchPage/Filters/Filters";
import SearchResults from "components/searchPage/SearchResults/SearchResults";

const PageContent = (): JSX.Element => {
	const [isFilterOpen, setIsFilterOpen] = useState(false);

	return (
		<>
			<HelmetProvider>
				<main className="wk-listing-page">
					<div className="wk-listing-page-content">
						<div className="wk-listing-page-content__inlay">
							<Filters isFilterOpen={isFilterOpen} setIsFilterOpen={setIsFilterOpen}/>
							<SearchResults isFilterOpen={isFilterOpen} setIsFilterOpen={setIsFilterOpen}/>
						</div>
					</div>
				</main>
			</HelmetProvider>
		</>
	);
};

export default PageContent;
